<template>
  <div class="instanceListSearch">
    <Row :gutter="4">
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input search v-model="environmentKey" :placeholder="$t('instance_list.selectByEnvironment')" @on-search="searchEnvironmentKeyName()"/>
      </Col>
      <Col span="4">
        <DatePicker type="date" :placeholder="$t('instance_list.selectByDate')" v-model="startDate" @on-change="searchStartDate()"></DatePicker>
      </Col>
    </Row>
  </div>
</template>
<script>
  import TableInstanceList from '../instance_list/TableInstanceList'
  var tableInstanceList = TableInstanceList;
  export default {
    name: 'InstanceListSearch',
    data() {
      return {
        environmentKey: '',
        startDate:''
      }
    },
    methods: {
      // 按环境查询
      searchEnvironmentKeyName: function(){
          eventBus.$emit('environmentKeySearchID', this.environmentKey);
          tableInstanceList.methods.showAll();
      },
      // 按日期查询
      searchStartDate: function(){
          eventBus.$emit('startDateSearchID', this.startDate);
          tableInstanceList.methods.showAll();
      }
    }
  }
</script>
<style scoped>
  .instanceListSearch {
    padding: 4px 0px 15px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/instance_lists/instance_list/InstanceListSearch.vue